import { Model } from 'pinia-orm';
import { Attr, MorphTo, Num, Str } from 'pinia-orm/dist/decorators';
import ContractEvent from './ContractEvent';
import Delay from './Delay';
import LabourDailyRecord from './LabourDailyRecord';
import PlantDailyRecord from './PlantDailyRecord';
import Project from './Project';
import PurchaseOrder from './PurchaseOrder';
import User from './User';
import VariationOrder from './VariationOrder';
/* --- user header --- */
/* --- end user header --- */

export default class Comment extends Model {
  static entity = 'App\\Models\\Comment';
  // fields
  @Num(0)
  declare id: number;
  @Str('')
  declare body: string;
  @Str('')
  declare commentable_type: string;
  @Num(0)
  declare commentable_id: number;
  @Str('')
  declare creator_type: string;
  @Num(0)
  declare creator_id: number;
  @Str('')
  declare created_at: string | undefined;
  @Str('')
  declare updated_at: string | undefined;
  @Attr({})
  declare metadata: Record<string, unknown> | undefined;
  // relations
  // TODO: 14/03/25 Add other classes
  @MorphTo(
    () => [LabourDailyRecord, PlantDailyRecord, Project, ContractEvent, VariationOrder, Delay, PurchaseOrder],
    'commentable_id',
    'commentable_type',
  )
  declare commentable:
    | LabourDailyRecord
    | PlantDailyRecord
    | Project
    | ContractEvent
    | VariationOrder
    | Delay
    | PurchaseOrder;
  @MorphTo(() => [User], 'creator_id', 'creator_type')
  declare creator: User;
  /* --- user code --- */

  public get createdAt(): Date {
    return new Date(this.created_at);
  }

  /* --- end user code --- */
}
